import { createApi } from '@reduxjs/toolkit/query/react';
import { btBaseQuery } from 'src/Common/common';

// Define a service using a base URL and expected endpoints
export const aceexpensesApi = createApi({
  reducerPath: 'aceexpensesApi',
  baseQuery: btBaseQuery,
  tagTypes: ['ACEExpenses'],

  endpoints: (builder) => ({
    getACEExpensess: builder.query<ac_eexpenses[], string>({
      query: (cid) => `aceexpenses/${cid}`,
      providesTags: ['ACEExpenses']
    }),
    getACEExpenses: builder.query<ac_eexpenses, string>({
      query: (id) => `aceexpenses/byid/${id}`
    }),
    insertACEExpenses: builder.mutation({
      query: (aceexpenses) => ({
        url: `aceexpenses/`,
        method: 'POST',
        body: aceexpenses
      }),
      invalidatesTags: ['ACEExpenses']
    }),
    updateACEExpenses: builder.mutation({
      query: (aceexpenses) => ({
        url: `aceexpenses/`,
        method: 'PUT',
        body: aceexpenses
      }),
      invalidatesTags: ['ACEExpenses']
    }),
    deleteACEExpenses: builder.mutation({
      query: (aceexpenses) => ({
        url: `aceexpenses/${aceexpenses.ee_id}`,
        method: 'DELETE',
        body: aceexpenses
      }),
      invalidatesTags: ['ACEExpenses']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetACEExpensessQuery,
  useGetACEExpensesQuery,
  useInsertACEExpensesMutation,
  useUpdateACEExpensesMutation,
  useDeleteACEExpensesMutation
} = aceexpensesApi;
